import "./App.css";
import React, { useState, useEffect, useMemo, useRef } from "react";
import Header from './components/Header';
import ControlPanel from "./components/ControlPanel";
import Game from './components/Game';
import Instructions from "./components/Instructions";
import HighscoresBoard from "./components/HighscoresBoard";
import { useStoredState, useStoredMoves } from "./customHooks/useStoredState";
import HighscoreModal from "./components/HighscoreModal";

 function App() {
 
// const jumbled = jumble();
const [newGameState, setNewGameState] = useStoredState(() => jumble(), "newgame");
const [isInstructions, setIsInstructions ] = useState(false); 
const [isHighscoresBoard, setIsHighscoresBoard] = useState(false);
const [newGame, setNewGame] = useState(false);
const [timer, setTimer] = useState(false);
const isInitialMount = useRef(true);
const [moves, setMoves] = useStoredMoves(0);
const [undoCount, setUndoCount] = useStoredState(0, "undoCount");
const [isCompeting, setIsCompeting] = useState(false);
const [hasWon, setHasWon] = useState(false);
const [onHighscoreBoard, setOnHighscorebord] = useState(false);
const [modalOpen, setModalOpen] = useState(false);
const [highscoresData, setHighscoresData] = useState([]);
const [highscoresNote, setHighscoresNote] = useState("");
const [time, setTime] = useStoredState(0, "storeTime");

 function startNewGame() {
  setNewGame(true);
 }
 useEffect(() => {
   if (isInitialMount.current) {
     isInitialMount.current = false;
     return; 
   } 
      const jumbledBoxContent = jumble();
     setNewGameState(() => (jumbledBoxContent));
     setNewGame(false);
   
    // return () => setNewGame(false);
 }, [newGame]); // setNewGame

 const fetchHighscores = async () => {
   try {
     setHighscoresNote("Loading highscores..");
     const response = await fetch(
       "https://iceyha0u6a.execute-api.us-east-1.amazonaws.com/dev/highscoresData"
     );
     if (!response.ok) {
       setHighscoresNote(`Error: ${response} ${response.statusText}`);
       throw new Error(`Error: ${response} ${response.statusText}`);
     }
     const result = await response.json();
     setHighscoresData(result);
     setHighscoresNote("Nice work!");
   } catch (error) {
     setHighscoresNote("Error fetching highscores.");
   } finally {
     // set loading false
   }
 };

 useEffect (() => {
  fetchHighscores();
 },[isInitialMount, isHighscoresBoard, hasWon, modalOpen]);

function checkHighscoreBoards() {
  fetchHighscores();
  console.log(highscoresData);
  let msTime = Math.floor(time);
  if(highscoresData.length < 100){
    setOnHighscorebord(true);
    return;
  }
  for(let i = 0; i < highscoresData.length; i++){
    if(msTime < highscoresData[i].time_taken){
      setOnHighscorebord(true);
      return;
    }
  }
   if (
     highscoresData[99].time_taken === msTime &&
     moves < highscoresData[99].moves
   ) {
    setOnHighscorebord(true);
     return;
   }
}
 
useEffect(
   () => {
     if (isCompeting && hasWon) {
       checkHighscoreBoards();
     }
   },
   [hasWon,
   isCompeting]
 );

 useEffect(() => {
   if (onHighscoreBoard) {
     setModalOpen(true);
     document.activeElement?.blur(); // stops control of buttons underneath
   }
 }, [onHighscoreBoard]);


function jumble() {
  let flatContent = [
    { value: "1", colour: "#b71234"},
    { value: "2", colour: "#b71234"},
    { value: "3", colour: "#b71234"},
    { value: "4", colour: "#b71234"},
    { value: "1", colour: "#0046ad"},
    { value: "2", colour: "#0046ad"},
    { value: "3", colour: "#0046ad"},
    { value: "4", colour: "#0046ad"},
    { value: "1", colour: "#009b48"},
    { value: "2", colour: "#009b48"},
    { value: "3", colour: "#009b48"},
    { value: "4", colour: "#009b48"},
    { value: "1", colour: "#ffd500"},
    { value: "2", colour: "#ffd500"},
    { value: "3", colour: "#ffd500"},
    { value: "4", colour: "#ffd500"},
  ];
   // Fisher-Yates shuffle, goes through backwards and swaps forwards with remaining values
   for (let i = flatContent.length - 1; i > 0; i--) {
     const j = Math.floor(Math.random() * (i + 1));
     [flatContent[i], flatContent[j]] = [flatContent[j], flatContent[i]];
   }

   let jumbleContent = [];
   for (let i = 0; i < 4; i++) {
     // Slice a chunk of 4 elements for each row and add it to the grid
     jumbleContent.push(flatContent.slice(i * 4, (i + 1) * 4));
   }

   return jumbleContent;

}

function showInstructions(){
  setIsInstructions(!isInstructions); 
}
function showTimer(){
  setTimer(!timer);
}

function showHighscoresBoard(){
  setIsHighscoresBoard(!isHighscoresBoard);
}
function onSubmitScore(playerName, time, moves){
  const payload = {
    playerName, 
    time,
    moves
  };
  try {
    const res = fetch ("https://e895ifjq5f.execute-api.us-east-1.amazonaws.com/submit-score", {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(payload)
    });
    const result = res.json();
    //set message ro result, name and time back to null.
  } catch {
    // set message to error
  }
}
  return (
    <>
      <div className="app">
        <Header />
        <ControlPanel
          handleNewGame={startNewGame}
          handleInstructions={showInstructions}
          handleTimer={showTimer}
          handleHighscoreBoard={showHighscoresBoard}
          moves={moves + undoCount}
          newGame={newGame}
          setIsCompeting={setIsCompeting}
          hasWon={hasWon}
          time={time}
          setTime={setTime}
        />
        <div className="gameContainer">
          <div className="instructionContainer">
            {isInstructions && (
              <Instructions handleInstructions={showInstructions} />
            )}
          </div>
          <Game
            gameState={newGameState}
            newGame={newGame}
            moves={moves}
            setMoves={setMoves}
            setUndoCount = {setUndoCount}
            hasWon={hasWon}
            setHasWon={setHasWon}
            setOnHighscoreBoard={setOnHighscorebord}
            
          />
          { <div className="highscoresContainer">
            {isHighscoresBoard && (
              <HighscoresBoard 
              handleHighscoreBoard={showHighscoresBoard}
              highscoresData={highscoresData}
              highscoresNote={highscoresNote}
              />
            )}
          </div> }
          {modalOpen && (
            <HighscoreModal   
              onSubmitScore={onSubmitScore}
              setModalOpen={setModalOpen}
              moves={moves + undoCount}
              time={time}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default App;
